var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{},[_c('vs-navbar',{staticClass:"vx-navbar navbar-custom navbar-skelton",class:_vm.navbarTextColor,staticStyle:{"box-shadow":"none"},attrs:{"color":_vm.navbarColor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }